interface FlagIconProps {
  svgString: string;
}

const FlagIcon = ({ svgString }: FlagIconProps) => (
  <div dangerouslySetInnerHTML={{ __html: svgString }} />
);

export default FlagIcon;
